<div class="pb-3"> <!-- Padding is here so that collapse animations will work properly; Rather than using margin on next child -->
  <div class="d-flex flex-wrap border-bottom border-gray-300" attr.data-cy="appRequirement-{{appRequirement && appRequirement.name}}">
    <div data-cy="appRequirement-collapse" class="col-12 px-0 py-1 d-flex" style="cursor: pointer;" (click)="toggleExpanded()">
      <div class="pr-2">
        <i class="fa fa-angle-down animate-rotation" [ngClass]="{'rotate-180': expanded}"></i>
      </div>

      <!-- App Requirement Headers -->
      <div *ngIf="appRequirement">
        <!-- Alias is a placeholder for app requirement name -->
        {{ appRequirement.name }}
      </div>
      <div *ngIf="appRequirement" class="ml-auto">
        {{ appRequirement.status | titlecase }}
      </div>

      <div *ngIf="bankRequirements && bankRequirements.length > 0">
        Bank Statements
      </div>
      <div class="ml-auto" *ngIf="bankRequirements && bankRequirements.length > 0" [ngClass]="{ 'text-danger': bankRequirementStatus === 'failed' }">
        {{ bankRequirementStatus | titlecase }}
      </div>
    </div>

    <div class="col-12 bg-light" *ngIf="expanded" [@expandInOut]>
      <div class="p-1">
        <!-- Value Requirements -->
        <div *ngIf="appRequirement">
          <div *ngFor="let issue of appRequirement.issues">
            <span [ngClass]="{ 'text-danger': issue.type === 'error' }">
              {{ issue.message }}
            </span>
            <div *ngIf="issue.type === 'warning' && (canEdit$ | async)">
              <label class="mb-3" [ngClass]="{ 'disabled': togglingIgnored[issue.requirementId] }">
                <input type="checkbox" class="mr-1" [disabled]="togglingIgnored[issue.requirementId]" [checked]="issue.ignored" (change)="toggleIgnored(issue)">
                <span>Ignore</span>
              </label>
            </div>
          </div>

          <div class="mb-3" *ngIf="fields && fields.length > 0">
            <app-requirement-form [fields]="fields" [borrowerId]="borrowerId" [editable]="(canEdit$ | async)" [displayableInfo]="displayableInfo"></app-requirement-form>
          </div>
        </div>
        <!-- Bank Requirements-->
        <div *ngIf="bankRequirements">
          <bank-requirements
            [borrowerId]="borrowerId"
            [bankRequirements]="bankRequirements"
            (met)="met.emit($event)">
          </bank-requirements>
        </div>
      </div>
    </div>
  </div>
</div>
